'use strict';

wbApp.factory('activityTariffSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var ActivityTariffs = $resource('/Api/ActivityTariffs/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/ActivityTariffs/GetAll' },
            'update': { method: 'POST', url: '/Api/ActivityTariffs/Update' },
            'insert': { method: 'POST', url: '/Api/ActivityTariffs/Insert' },
            'delete': { method: 'POST', url: '/Api/ActivityTariffs/Delete' }
        });

        var activityTariffs;
        var nonDeleted;

        function createNew() {
            return {
                price: 0
            };
        }

        function getAllAsync(reload) {
            if (!activityTariffs || reload) {
                activityTariffs = repositorySvc.customGet('getAll', ActivityTariffs);
                nonDeleted = null;
            }

            return activityTariffs;
        }


        function getAllNonDeletedAsync(reload, activityTariffID) {
            if (nonDeleted && !reload) {
                return nonDeleted;
            }

            var allActivityTariffs = getAllAsync(reload);
            nonDeleted = [];
            var deferred = $q.defer();
            nonDeleted.$promise = deferred.promise;

            allActivityTariffs.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (!value.isDeleted || value.activityTariffID === activityTariffID) {
                        nonDeleted.push(value);
                    }
                });
                deferred.resolve(nonDeleted);
            }, function (reason) {
                deferred.reject(reason);
            });

            return nonDeleted;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                ActivityTariffs,               // $resource
                activityTariffs,               // collection
                data,                          // entity
                success,
                errorCallback,
                'activityTariffID');

            function success(entity) {
                repositorySvc.entityInserted(nonDeleted, entity);

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                ActivityTariffs,            // $resource
                activityTariffs,            // collection
                data,                       // entity
                success,
                errorCallback,
                'activityTariffID');

            function success(entity) {
                repositorySvc.entityUpdated(nonDeleted, entity, 'activityTariffID');

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                ActivityTariffs,              // $resource
                activityTariffs,              // collection
                data,                         // entity
                success,
                errorCallback,
                { activityTariffID: data.activityTariffID },
                'activityTariffID');

            function success() {
                repositorySvc.entityRemoved(nonDeleted, data.id, 'activityTariffID');

                if (successCallback) {
                    successCallback();
                }
            }
        }

        return {
            createNew: createNew,
            getAllAsync: getAllAsync,
            getAllNonDeletedAsync: getAllNonDeletedAsync,
            insert: insert,
            update: update,
            remove: remove
        }
    }]);